import {NavigationForPC} from './NavigationForPC';
import {NavigationForSP} from './NavigationForSP';
import type {NavValueType} from './constants';

type Props = {
  navValue: NavValueType;
  setNavValue?: (value: NavValueType) => void;
  handleOpenModal?: () => void;
};

export const Navigation: React.FC<Props> = ({
  navValue,
  setNavValue,
  handleOpenModal,
}) => {
  return (
    <>
      <div className="hidden pc:block">
        <NavigationForPC
          navValue={navValue}
          setNavValue={setNavValue}
          handleOpenModal={handleOpenModal}
        />
      </div>
      <div className="pc:hidden">
        <NavigationForSP
          navValue={navValue}
          setNavValue={setNavValue}
          handleOpenModal={handleOpenModal}
        />
      </div>
    </>
  );
};
